import { combineReducers } from 'redux'

import {
    SET_HEADER_COLOUR,
    SET_HAS_SUB_MENU
} from '../actions'

const headerColour = (state = {}, action) => {
    switch(action.type){
        case SET_HEADER_COLOUR:
            return assignValueForPath(state, action.path, action.colour ? action.colour : null)
        default:
            return state
    }
}

const hasSubMenu = (state = {}, action) => {
    switch(action.type){
        case SET_HAS_SUB_MENU:
            return assignValueForPath(state, action.path, action.bool)
        default:
            return state
    }
}

const assignValueForPath = (state, path, value) => {
    return {
        ...state,
        ...{
            [path]: value
        }
    }
}

export default combineReducers({
    headerColour,
    hasSubMenu
})